import { Component, OnInit, ViewChild, TemplateRef, inject } from '@angular/core';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableComponent } from 'projects/bis-shared/src/lib/datatable/datatable/datatable.component';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { ObjectTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { DatatableColumnWidth } from 'projects/bis-shared/src/lib/datatable/datatable-column-width';
import { FilterDataType } from 'projects/bis-shared/src/lib/datatable/datatable-filter/filter-operations';
import { DatatableModule } from 'projects/bis-shared/src/lib/datatable/datatable.module';
import { UtilityModule } from 'projects/bis-shared/src/lib/utility/utility.module';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-inactive-prior-auth-list-component',
  templateUrl: './inactive-prior-auth-list.component.html',
  styleUrls: ['./inactive-prior-auth-list.component.scss'],
  imports: [
    DatatableModule,
    UtilityModule,
    RouterModule,
  ],
})
export class InActivePriorAuthListComponent implements OnInit {
  private externalApiUrls = inject(ExternalApiUrls);

  @ViewChild(DatatableComponent, { static: true }) datatableComponent: DatatableComponent;
  @ViewChild('idTemplate', { static: true }) idTemplate: TemplateRef<any>;
  @ViewChild('injuryDateTemplate', { static: true }) injuryDateTemplate: TemplateRef<any>;
  @ViewChild('patientDisplay', { static: true }) patientDisplay: TemplateRef<any>;
  @ViewChild('priorAuthStatusDisplay', { static: true }) priorAuthStatusDisplay: TemplateRef<any>;
  @ViewChild('caseNumberDisplay', { static: true }) caseNumberDisplay: TemplateRef<any>;
  columns: DatatableColumn[];
  dataUrl: string;
  defaultSort: DatatableSort[];
  AppUrls = AppUrls;
  priorAuthTypeCode = ObjectTypeCode.PriorAuthorization;

  
 

  constructor() {
    this.defaultSort = [
      {
        property: 'priorAuthStatusDate',
        sortAscending: false,
      },
      {
        property: 'patient',
        sortAscending: true,
      },
    ];
  }

  ngOnInit() {
    this.setColumns();
    this.dataUrl = this.externalApiUrls.priorAuthorization.priorAuthorizationCompletedWorkRequest();
  }

  setColumns() {
    this.columns = [
      {
        title: 'PAR ID',
        property: 'priorAuthorizationId',
        filterDataType: FilterDataType.SystemId,
        filterSystemIdFixedTypeCode: ObjectTypeCode.PriorAuthorization,
        template: this.idTemplate,
      },
      { title: 'Type', property: 'type', filterDataType: FilterDataType.Reference },
      {
        title: 'Patient',
        property: 'patient',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'DOB',
        property: 'dateOfBirth',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.UtcDateTemplate,
      },
      {
        title: 'PAR Status',
        property: 'priorAuthStatus',
        filterDataType: FilterDataType.Reference,
      },
      {
        title: 'PAR Status Date',
        property: 'priorAuthStatusDate',
        filterDataType: FilterDataType.Date,
        template: DatatableStaticTemplateType.EasternDateTimeHMSTemplate,
      },
      {
        title: 'Injury Date',
        property: 'dateOfInjury',
        filterDataType: FilterDataType.Date,
        width: DatatableColumnWidth.medium,
        template: this.injuryDateTemplate,
      },
      {
        title: 'WCB Case #',
        property: 'wcbCaseNumber',
        filterDataType: FilterDataType.String,
        template: DatatableStaticTemplateType.CaseNumberTemplate,
        width: DatatableColumnWidth.large,
      },
      {
        title: 'Claim Admin Claim #',
        property: 'claimAdminClaimNumber',
        filterDataType: FilterDataType.String,
      },
      {
        title: 'Employer Name',
        property: 'employerName',
        filterDataType: FilterDataType.String,
      },
      { title: 'Insurer', property: 'insuranceCarrier', filterDataType: FilterDataType.String },
      { title: 'Provider', property: 'provider', filterDataType: FilterDataType.String },
      {
        title: 'Medication',
        property: 'medicationRequested',
        filterDataType: FilterDataType.String,
      },
    ];
  }
}
